import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CasualHireFormInstitutionsResolver } from './casual-hire-form-resolvers.service';
import { CasualHireFormComponent } from './casual-hire-form.component';
import { HireFormIntroComponent } from './intro/intro.component';
import { HireFormDetailsPaymentComponent } from './steps/details-payment/details-payment.component';
import { HireFormOrderConfirmationComponent } from './steps/order-confirmation/order-confirmation.component';
import { HireFormSelectCollectionDateComponent } from './steps/select-collection-date/select-collection-date.component';
import { FormStepperSelectInstitutionComponent } from './steps/select-institution/select-institution.component';
import { HireFormSelectQualificationsComponent } from './steps/select-qualifications/select-qualifications.component';
import { HireFormSelectRegliaCopmonent } from './steps/select-regalia/select-regalia.component';
import { SelectCollectionDateResolver } from './steps/select-collection-date/select-collection-date.resolver';

const routes: Routes = [
	{
		path: '',
		component: CasualHireFormComponent,
		children: [
			{
				path: '',
				redirectTo: 'intro',
				pathMatch: 'full'
			},
			{
				path: 'intro',
				component: HireFormIntroComponent,
				data: {
					displayStepper: false
				}	
			},
			{
				path: 'select-institution',
				resolve: {
					institutions: CasualHireFormInstitutionsResolver
				},
				component: FormStepperSelectInstitutionComponent
			},
			{
				path: 'select-qualifications',
				component: HireFormSelectQualificationsComponent
			},
			{
				path: 'select-collection-date',
				component: HireFormSelectCollectionDateComponent,
				resolve: {
					availableDates: SelectCollectionDateResolver
				}
			},
			{
				path: 'select-regalia',
				component: HireFormSelectRegliaCopmonent
			},
			{
				path: 'details-payment',
				component: HireFormDetailsPaymentComponent
			},
			{
				path: 'order-confirmation',
				component: HireFormOrderConfirmationComponent
			}
		]
	},
	
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class CasualHireFormRoutingModule { }
